<template>
  <div id="knowledgeDetail">
    <bread :content="breadContent"></bread>
    <p class="Page-title">应急常识</p>
    <el-divider></el-divider>
    <div class="container">
      <blockTime :year="time.year" :month="time.month" :day="time.day"></blockTime>
      <Article :width="'80%'" :margin="'20px 10% 0 75px'" :title="detailData.Title" :html="detailData.Content"></Article>
    </div>
  </div>
</template>
<script>
import bread from "@/components/bread";
import timeline from "@/components/timeline";
import Article from "@/components/article";
import Api from "@/network.js";
import blockTime from "@/components/blockTime";

export default {
  name: "knowledgeDetail",
  components: {
    bread,
    Article,
    timeline,
    blockTime
  },
  async beforeRouteEnter(to, from, next) {
    let res = await Api.emrClass.getKnowledgeDetail(to.query.id);
    next(vm => {
      vm.detailData = res;
      vm.time = vm.$utils.timeResult(vm.detailData.AdminSetTime);
      // 指定高亮菜单栏文字
      vm.$store.commit('setHighlightText', '应急常识')
    });
  },
  data() {
    return {
      breadContent: [
        { text: "首页", routerName: "index" },
        { text: "应急课堂", routerName: "emrClass" },
        { text: "应急常识", routerName: "" }
      ],
      detailData: {},
      time: {}
    }
  },
  // 离开详情页时清除侧边栏高亮项，防止冲突
  destroyed() {
    this.$store.commit('setHighlightText', '')
  }
};
</script>
  
<style lang="scss" scoped>
#knowledgeDetail {
  width: calc(100% - 250px);
  margin-left: 50px;
  margin-top: 40px;
}

.container {
  position: relative;
  padding-top: 10px;
  .blockTime {
    position: absolute;
    left: 0;
    top: -10px;
  }
}
</style>

